/**
 * @generated SignedSource<<fa703bffa2fcf6b3d535ec0ed00458d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreRelativeZonedDate_StoreZonedDate$data = {
  readonly isoString: string;
  readonly timezone: string;
  readonly " $fragmentType": "StoreRelativeZonedDate_StoreZonedDate";
};
export type StoreRelativeZonedDate_StoreZonedDate$key = {
  readonly " $data"?: StoreRelativeZonedDate_StoreZonedDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreRelativeZonedDate_StoreZonedDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreRelativeZonedDate_StoreZonedDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isoString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    }
  ],
  "type": "StoreZonedDate",
  "abstractKey": null
};

(node as any).hash = "6af4bbd098ec479bc9e023f9b185c883";

export default node;
